<template>
  <div>
    <div v-if="data" class="roundbox">
      <tab :tabs="tabs" v-model="tab" ref="tabs"></tab>

      <fieldset id="tab-general" v-show="tab == 'general'">
        <div class="rbcontent">
          <table class="table table-borderless table-sm ozet">
            <tbody>
              <tr>
                <td style="width: 10px">İşin Adı</td>
                <td style="width: 1px">:</td>
                <td style="font-weight: bold">
                  {{ data.Title }}
                </td>
              </tr>

              <tr>
                <td style="width: 10px">Takip No</td>
                <td style="width: 1px">:</td>
                <td style="font-weight: bold">
                  {{ data.TrackingNo | trackingNo }}
                </td>
              </tr>
              <tr v-show="data.Description">
                <td>Açıklama</td>
                <td>:</td>
                <td>{{ data.Description }}</td>
              </tr>
              <tr v-if="data.CirculationProfileSchema">
                <td>Dolaşım Profili</td>
                <td>:</td>
                <td>{{ data.CirculationProfileSchema.Name }}</td>
              </tr>
              <tr v-show="data.TargetDate">
                <td>Hedeflenen Bitiş</td>
                <td>:</td>
                <td>{{ data.TargetDate | date }}</td>
              </tr>
              <tr>
                <td>Durum</td>
                <td>:</td>
                <td>
                  <label class="badge" :class="'bg-' + jobStatusClass">{{
                    jobStatusLabel
                  }}</label>
                </td>
              </tr>
              <tr>
                <td>Türü</td>
                <td>:</td>
                <td>
                  <job-document-type :documentType="data.DocumentType" />
                  <span v-show="data.Amount">
                    —
                    <span class="text-muted">{{ data.Amount | money }} {{ data.Currency }}</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold; color: #000">Dosyalar</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style="padding: 0" colspan="3">
                  <!-- @click="downloadDocument(d)" -->
                  <div v-for="d in data.Documents" :key="d.id" class="documentContainer">
                    <file-download-link :isActive="userActions.CanDownload" :isOnlineView="onlineViewEnabled"
                      :document="d" @download="downloadDocument" @preview="showFilePreview"
                      :isDocumentFormat="isFilePattern"></file-download-link>
                    <div style="float: right;">
                      {{ d.UnsignedFile.Size | prettyBytes }}
                    </div>
                    <!-- <a class="">{{ d.UnsignedFile.FileName }}</a> -->
                  </div>
                </td>
              </tr>
              <tr v-show="data.Attachments && data.Attachments.length > 0">
                <td style="font-weight: bold; color: #000">Ekler</td>
                <td></td>
                <td style="padding: 0"></td>
              </tr>
              <tr>
                <td style="padding: 0" colspan="3">
                  <div v-for="d in data.Attachments" :key="d.id" class="documentContainer">
                    <file-download-link :isActive="userActions.CanDownload" :isOnlineView="onlineViewEnabled"
                      :document="d" @download="downloadAttachment" @preview="showFilePreview"
                      :isDocumentFormat="isFilePattern"></file-download-link>
                    <div style="float: right">{{ d.Size | prettyBytes }}</div>
                    <!-- <a class="">{{ d.FileName }}</a> -->
                  </div>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold; color: #000">Alıcılar</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style="padding: 0" colspan="3">
                  <div v-for="f in data.Finalizers" :key="f.Id" style="
                      border: 1px solid #ddd;
                      margin-bottom: 10px;
                      padding: 6px 12px;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: space-between;
                      ">
                    <b>{{ f.TargetSystem.Name }}</b>
                    <div style="display: flex; flex-direction: row; gap: 5px;">
                      <button type="button" class="btn btn-sm btn-outline-info" @click="$emit('showFinalizerDetail', f)">Detay</button>
                      <button type="button" class="btn btn-sm btn-success"  v-show="(f.State == 'Waiting' || f.State == 'Fail') && f.TargetSystem.Kind == 'Rem'" @click="sendWithMobileSignature(f)">Mobil İmzala</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </fieldset>
      <fieldset id="tab-flowsummary" v-show="tab == 'flowsummary'">
        <div class="col rbcontent">
          <table class="table table-borderless table-hover table-flow-summary">
            <tbody>
              <tr v-for="s in data.FlowSummary" :key="s.Date" style="border-bottom: 1px solid rgba(0, 0, 0, 0.04)">
                <td style="
                    width: 1px;
                    vertical-align: top;
                    text-align: center;
                    padding-left: 12px;
                    opacity: 0.7;
                  ">
                  <svg v-if="s.Tense == 'Past'" title="İşlem tamamlandı" width="1.7em" height="1.7em" fill="currentColor"
                    class="bi bi-arrow-right-circle" viewBox="0 0 16 16" :class="[
                      s.Type == 'Decline' ? 'text-danger' : 'text-success',
                      s.Type == 'Cancel' ? 'text-warning' : 'text-success',
                    ]">
                    <path
                      d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                  </svg>

                  <svg v-if="s.Tense == 'Present'" title="Bu işlem bekleniyor" width="1.7em" height="1.7em"
                    fill="currentColor" class="bi bi-arrow-right-circle-fill text-primary" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                  </svg>

                  <svg v-if="s.Tense == 'Future'" title="İşlem henüz gerçekleşmedi" width="1.6em" height="1.6em"
                    viewBox="0 0 16 16" class="text-muted bi bi-hourglass-split" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                      d="M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07A7.001 7.001 0 0 1 8 16 7 7 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3zm0 2.1a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 0 1 .5-.5z" />
                  </svg>

                  <svg v-if="s.Tense == 'Canceled'" title="İşlem iptal edildi" width="1.6em" height="1.6em"
                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="text-warning bi bi-dash-circle"
                    viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                  </svg>
                </td>
                <td>
                  <div class="row">
                    <div class="">
                      <div v-if="s.TargetSystem">
                        <span class="text-muted">Alıcı:</span>
                        {{ s.TargetSystem.Name }}
                      </div>
                      <div>
                        <span v-for="(u, index) in s.Relateds" :key="u.Id">
                          <span v-if="index > 0">,</span>
                          <img :src="getDefaultProfilePictureIfNull(u.ProfilePictureUrl)
                            " class="flow-picture" />
                          <b>{{ u.Name }}</b>
                        </span>
                      </div>
                      <div style="font-size: 0.9rem; padding-top: 3px">
                        <span v-if="s.Tense == 'Canceled'">
                          <span style="text-decoration: line-through">{{
                            s.Description
                          }}</span>
                        </span>
                        <span v-else>
                          <icon-dash-circle v-if="s.Type == 'Cancel'" class="text-warning" />
                          <icon-x-circle v-if="s.Type == 'Decline'" class="text-danger" />
                          <icon-circle v-if="s.Type == 'UndoCancel'" class="text-primary" />
                          {{ s.Description }}
                        </span>
                        <span class="fixed-right text-muted">
                          <small>{{ s.Date | datetime }}</small>
                        </span>
                      </div>
                      <small class="text-muted" v-show="s.Note">
                        {{ s.Note }}
                      </small>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </fieldset>
      <div class="commands">
        <div class="row">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-danger" @click="$emit('cancel')" v-if="userActions.CanCancel">
              İptal
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="note note-warning">
        <h3>Bilgi</h3>
        <p>Kayıt bulunamadı.</p>
      </div>
    </div>
    <file-preview v-if="fileDetail" :file="fileDetail" :viewer="viewerType" :isOnlineView="onlineViewEnabled"
      @close="fileDetail = null;"></file-preview>
  </div>
</template>
<script>
import axios from "axios";
import JobDocumentType from "../components/JobDocumentType.vue";
import tab from "../components/Tab.vue";
import FileDownloadLink from "./FileDownloadLink.vue";
import FilePreview from "./FilePreview.vue";

import iconDashCircle from '../components/Icons/dash-circle.svg'
import iconXCircle from '../components/Icons/x-circle.svg'
import iconCircle from '../components/Icons/circle.svg'

export default {
  components: {
    JobDocumentType,
    tab,
    iconDashCircle,
    iconXCircle,
    iconCircle,
    FileDownloadLink,
    FilePreview
  },
  data() {
    return {
      documentInfo: null,
      fileDetail: null,
      onlineViewEnabled: true,
      sendRemFinalizer: null,     // KEP iletisi gönderilmek üzere imzalanan hedef sistem
      mobileItems: null,
      tab: "general",
      tabs: [
        { key: "general", text: "İş Bilgileri" },
        { key: "flowsummary", text: "Dolaşım Adımları" },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    userActions: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.getOnlineViewPermission()
      .then(x => {
        console.log(x)
        this.onlineViewEnabled = x;
      }).catch(x => {
        console.warn("getOnlineViewPermission alınamadı:", x);
        this.onlineViewEnabled = true;
      });
  },
  computed: {
    jobStatusLabel() {
      if (!this.data || !this.data.State) return null;
      return this.$izonay.jobStatus[this.data.State]?.text;
    },
    jobStatusClass() {
      if (!this.data || !this.data.State) return null;

      return this.$izonay.jobStatus[this.data.State]?.css;
    },
    isFilePattern() {
      var filePatternFound = true;
      this.data.Finalizers.forEach(finalizer => {
        if (finalizer.TargetSystem.DocumentFormat == null || finalizer.TargetSystem.DocumentFormat == 'None') {
          filePatternFound = false;
        }
      });
      return filePatternFound;
    }
  },
  methods: {
    sendWithMobileSignature(finalizer) {
      // Mobil İmza ile KEP gönderimi için imza panelini açar

      this.sendRemFinalizer = finalizer;
      this.mobileItems = [];

      if (finalizer.RemOperation.ESignLogin) {
        this.mobileItems.push({
          DocumentId: "agreement",
          SignatureFormat: "CAdES",
          FileName: "KEP oturum taahhütnamesi.txt",
          State: '',
          FingerprintUrl: `/Rem/CalculateFingerprintForLogin/?jobId=${this.data.Id}&documentId=agreement&finalizerId=${finalizer.Id}`,
          PostUrl: `/Rem/SignMobileForLogin/?jobId=${this.data.Id}&documentId=agreement&finalizerId=${finalizer.Id}&fingerPrintTempFileId={0}`,
          PostParams: { JobId: this.data.Id, DocumentId: 'agreement', FinalizerId: finalizer.Id }
        });
      }

      this.mobileItems.push({
        DocumentId: "mime",
        SignatureFormat: "CAdES",
        FileName: "KEP iletisi.eml",
        State: '',
        FingerprintUrl: `/Rem/CalculateFingerprint/?jobId=${this.data.Id}&documentId=mime&finalizerId=${finalizer.Id}`,
        PostUrl: `/Rem/SignMobile/?jobId=${this.data.Id}&documentId=mime&finalizerId=${finalizer.Id}&fingerPrintTempFileId={0}`,
        PostParams: { JobId: this.data.Id, DocumentId: 'mime', FinalizerId: finalizer.Id }
      });

      this.$emit('mobileSign', this.mobileItems,this.sendRemFinalizer)
    },

    showFilePreview(document, type, isFormatted) {
      console.log(document);
      this.fileDetail = document;
      this.viewerType = type;
      this.fileDetail.EntityId = this.data.Id;
      if(isFormatted)
          this.fileDetail.IsFormatted = true;
      else
          this.fileDetail.IsFormatted = false;
      console.log(this.fileDetail)
    },
    downloadDocument(document, menuKey) {
      // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.

      return axios
        .post(`/job/createDocumentUrl/`, {
          EntityId: this.data.Id,
          DocumentId: document.Id,
          IsSigned: menuKey == 'downloadSigned' ? true : false,
        })
        .then((x) => {
          console.log("createDocumentUrl Result:", x.data);
          this.documentInfo = {
            FileName: document.UnsignedFile.FileName,
            Size: document.UnsignedFile.Size,
            Url: x.data.Data.Url,
          };

          window.open(x.data.Data.Url);
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    downloadAttachment(attachment) {
      // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
      return axios
        .post(`/job/createAttachmentUrl/`, {
          EntityId: this.data.Id,
          AttachmentId: attachment.Id,
        })
        .then((x) => {
          console.log("createAttachmentUrl Result:", x.data);
          attachment.Url = x.data.Data.Url;

          this.documentInfo = {
            FileName: attachment.FileName,
            Size: attachment.Size,
            Url: x.data.Data.Url,
          };

          this.documentInfo = attachment;
          console.log(JSON.stringify(this.documentInfo));
          window.open(x.data.Data.Url);
        })
        .catch((x) => {
          switch (x.response.status) {
            case 404:
              this.$izonayAlert("Kayıt bulunamadı.");
              break;
            default:
              this.errorMessage = "İşlem gerçekleştirilemedi: " + x;
              break;
          }
          this.loading = false;
        });
    },
    approve() {
      this.loading = true;
      var url = `/job/approve/`;
      return axios
        .post(url, { JobId: this.$route.params.id, description: "" })
        .then((x) => {
          console.log("POST Result:", x.data);

          if (x.data.Success) {
            this.data = x.data.Data.Job;
            this.userActions = x.data.Data.UserActions;
            this.view = "detail";
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
          }

          this.loading = false;
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
  },
};
</script>
<style scoped>
.roundbox {
  background: #fff;
  border-radius: 8px;
  /* box-shadow: 0px 2px 1px 1px #DDDD; */
  padding-top: 1px;
}

.roundbox .rbcontent {
  padding: 20px 5px 20px 5px;
}

.roundbox .rbcontent.head {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 14px 30px 24px 30px;
}

.roundbox .rbcontent.form {
  background-color: #f7f7f7;
}

.roundbox .rbcontent.head h2 {
  position: relative;
  top: 8px;
  display: inline;
}

.roundbox .rbcontent.footer {
  padding: 14px 30px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.table-flow-summary td,
.table-flow-summary th {
  padding: 0.75rem;
  vertical-align: top;
}

.col-left {
  display: flow-root;
  width: 95%;
}

.flow-picture {
  width: 1.4em;
  height: 1.4em;
  vertical-align: middle;
  margin-right: 4px;
  border-radius: 1.2em;
}

.nav.nav-pills li a.active {
  background: none;
  border-bottom: 4px solid #35495e !important;
  color: #35495e;
}

.nav.nav-pills a {
  color: #808080 !important;
  border-radius: 0;
  background: #fff;
  border-bottom: 4px solid #fff;
  font-size: 18px;
  text-decoration: none !important;
}

.nav.nav-pills a:hover {
  background: none;
  color: #35495e;
}

a {
  color: #0d6efd !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}

.note-warning {
  border-color: #f0ad4e;
  background: #fcf8e3;
}

.note {
  margin: 0 0 20px 0;
  padding: 15px 30px 15px 15px;
  border-left: 3px solid #e5e5e5;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

.note h1,
.note h2,
.note h3,
.note h4 {
  margin-top: 0;
}

.note p:last-child {
  margin-bottom: 0;
}

p {
  margin: 0 0 10px;
}

.fixed-right {
  position: absolute;
  right: 1rem;
}

.documentContainer {
  z-index: 1 !important;
  opacity: 1 !important;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
</style>
